<template>
  <div>
    <notifications group="foo" />
    <router-view />
  </div>
</template>

<script>
export default {
};
</script>
